export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const REMOVE1_FROM_CART = "REMOVE1_FROM_CART";
